import { styled } from '$utils/theme'
import { Button } from '$views/components'
import { Icon } from '$views/components/Icon'

export const StyledSearchHereButton = styled(Button)`
  z-index: 1;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25);
  position: absolute;
  left: 0px;
  right: 0px;
  margin: auto;
  top: 1rem;
  width: fit-content;
`

export const StyledSearchHereIcon = styled(Icon)`
  position: relative;
  top: 3px;
`



// WEBPACK FOOTER //
// ./src/views/FullMapCaretakers/components/SearchHereButton/SearchHereButton.style.ts